export default __webpack_public_path__ + "static/media/mobile-login-pana.6189692d.svg";